export default __webpack_public_path__ + "static/media/highlight_1.b4efec8f.jpg";